import { Component, OnInit } from '@angular/core';
import { MatDialogConfig } from '@angular/material';
import { CommonFunctionService } from 'app/services/common-function.service';
import { CommonModalService } from 'app/services/common-modal.service';
import { DownloadService } from 'app/services/download.service';
import { UserService } from 'app/services/user.service';
import { ToastrService } from 'ngx-toastr';
import { ModalDownloadLayersComponent } from './modal-download-layers/modal-download-layers.component';

@Component({
  selector: 'app-feat-download-layers',
  templateUrl: './feat-download-layers.component.html',
  styleUrls: ['./feat-download-layers.component.css']
})
export class FeatDownloadLayersComponent implements OnInit {

	constructor(
		private toastr: ToastrService,
		private commonService: CommonFunctionService,
		private downloadService: DownloadService,
		private modalService: CommonModalService,
		private userService: UserService
	) { }

	async clickDownload() {
		const options: MatDialogConfig = {
			height: '80%',
			width: '500px'
		}
		const rsp = await this.modalService.openModalWindow(ModalDownloadLayersComponent, options);
		if (rsp && rsp.layers) {
			// const spinnerId = this.commonService.getRandomId();
			// this.commonService.setLoadingSpinner(true, spinnerId);
			try {
				const email = this.userService.customerInfo.adminEmails ? this.userService.customerInfo.adminEmails.join() : null;
				const cusName = this.userService.getUserInfo().customerName;
				this.toastr.success('A download link will be sent to your email.');
				await this.downloadService.fileGet(rsp.layers, cusName, email, cusName);
				// this.toastr.success('A download link has been sent to your email.');
			} catch (err) {
				console.log(err);
			}
			// this.commonService.setLoadingSpinner(false, spinnerId);
		}
	}
	ngOnInit() {
	}

}
